import { Chatroom, TaskData } from '../models';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { getMemberDetail } from '../utils/api-calls/getMemberDetail';
import useLoading from '../contexts/LoadingContext';

export function useTaskResult(
  memberId: string | undefined,
  room: Chatroom | undefined,
  day: number | undefined
): [TaskData[], Dispatch<SetStateAction<TaskData[]>>] {
  const [taskResult, setTaskResult] = useState<TaskData[]>([]);
  const { setIsLoading } = useLoading();

  useEffect(() => {
    if (!room || !day || !memberId) {
      return;
    }

    setIsLoading(true);
    getMemberDetail(memberId, room, day)
      .then((data) => {
        setTaskResult(data.result);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [room, day, memberId, setIsLoading]);

  return [taskResult, setTaskResult];
}
